// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"345":"e0d5c153","453":"05acab46","696":"3a49f96c"}[chunkId] + ".chunk.js");